module.exports = __webpack_public_path__ + "static/media/cr_2.a444cfcc.png";